const allowedChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "ArrowLeft", "ArrowRight", "Backspace", "Delete", "Tab"];
const mutatorChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
const modifierChars = ["Backspace", "Delete"];

export type TFormatInput = {
  inputFormatted: string;
  inputValue: string;
  cursorPosition: number;
};

export function formatInput(formattedValue: string, selectionStart: number, formatMask: string): TFormatInput {
  if (!formattedValue)
    return {
      inputFormatted: "",
      inputValue: "",
      cursorPosition: 0,
    };
  const clearedValue = formattedValue.replaceAll(" ", "");
  const clearedValueLength = clearedValue.length;
  let inputResult = "";
  let shift = 0;
  let cursorPosition = selectionStart;
  for (let index = 0; index < formatMask.length; index++) {
    if (clearedValueLength < index - shift) break;
    if (formatMask[index] === "N" && clearedValue[index - shift] === "0") {
      cursorPosition--;
      continue;
    }
    if (formatMask[index] === "X" || (formatMask[index] === "N" && clearedValue[index - shift] !== "0")) {
      inputResult += clearedValue[index - shift] || "";
      continue;
    }
    formatMask[index] === " " && shift++;
    inputResult += formatMask[index];
  }

  if (
    inputResult[selectionStart - 1] === " " &&
    cursorPosition < inputResult.trimEnd().length + 2 &&
    inputResult.trimEnd().length > formattedValue.length
  ) {
    cursorPosition++;
  }

  return {
    inputFormatted: inputResult.trimEnd() || "",
    inputValue: inputResult.replaceAll(" ", ""),
    cursorPosition: cursorPosition,
  };
}

export function keyFilter(event: React.KeyboardEvent<HTMLInputElement>, formatMask: string, countryPrefix: string) {
  const target = event.target as HTMLInputElement;

  if (event.key === "Tab" || target.selectionStart === null) return;

  if (!allowedChars.includes(event.key)) {
    event.preventDefault();
    return;
  }

  if (formatMask[target.selectionStart] === "N" && event.key === "0") {
    event.preventDefault();
    return;
  }

  if (
    (event.key === "ArrowLeft" && target.selectionStart < countryPrefix.length + 1) ||
    (event.key === "ArrowRight" && target.selectionStart < countryPrefix.length)
  ) {
    target.selectionStart = countryPrefix.length;
    event.preventDefault();
    return;
  }

  if (modifierChars.includes(event.key) && target.selectionStart < countryPrefix.length + 1) {
    event.preventDefault();
    return;
  }

  if (mutatorChars.includes(event.key) && (target.selectionStart < countryPrefix.length || target.value.length > formatMask.length - 1)) {
    event.preventDefault();
    return;
  }

  if (event.key === "Backspace" && target.value[target.selectionStart - 1] === " " && target.selectionStart - 1 > countryPrefix.length) {
    target.setSelectionRange(target.selectionStart - 1, target.selectionStart - 1);
  }
}
